export const defaultPositionStrategy = () => {
  const portalPadding = 8;
  return (
    parentRect: { left: number; bottom: number; width: number },
    portalRect: { width: number }
  ): { left: number; top: number; position?: number } => ({
    left: parentRect.left - portalRect.width + parentRect.width,
    top: parentRect.bottom + portalPadding
  });
};
